import React from 'react';

import './CopyToClipboard.scss';
import common from '../../common/common';

const CopyToClipboard = (props) => {
    const copyContent = (e) => {
        e.preventDefault();
        if (window.isSecureContext) {
            navigator.clipboard.writeText(props.url);
        } else {
            const textField = document.createElement('textarea');
            textField.innerText = props.url;
            document.querySelector('.copyToClipboard').appendChild(textField);
            textField.select();
            document.execCommand('copy');
            textField.remove();
        }

        e.currentTarget.style.transitionDuration = '0s';
        e.currentTarget.style.backgroundColor = '#ffffff';

        setTimeout(() => {
            document.querySelector(
                '.copyToClipboard'
            ).style.transitionDuration = '0.5s';
            document.querySelector('.copyToClipboard').style.backgroundColor =
                '#ffe500';
        }, 1000);
    };

    return (
        <div
            className='share-container--icon copyToClipboard'
            onClick={copyContent}>
            <img
                src={common.contentFromCdn({
                    path: `/Content/img/link.svg`,
                    keepUrlAsIs: false,
                })}
            />
        </div>
    );
};

export default CopyToClipboard;
